import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Dispatcher } from "./SiteAboutPageUtils/siteAboutInterfaces";
import { handleScheduleTabChange } from "./SiteAboutPageUtils/handleScheduleTabChange";
const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { handleCreateInitialTimeSchedules } from "./SiteAboutPageUtils/handleCreateInitialTimeSchedules";
import { handleConvertSchedulesToBooleanArrays } from "./SiteAboutPageUtils/handleConvertSchedulesToBooleanArrays";
import { handleCreateDuskToDawn } from "./SiteAboutPageUtils/handleCreateDuskToDawn";
import { handleCreateDuskToDawnLocationPlusBuffer } from "../SitesPage/SitesPageUtils/handleCreateDuskToDawnLocationPlusBuffer";
export const SchedulesTabs = () =>
  //   {
  //   clickedSchedulesTab,
  //   setClickedSchedulesTab,
  //   siteSchedules,
  //   visibleSchedules,
  //   setScheduleGrid,
  //   setTimeRanges,
  //   setGrid,
  //   setDuskToDawn,
  //   setDuskToDawnLocation,
  //   setSelectedDayInfo,
  //   setEditTimeScheduleDialogOpen,
  //   setMatchingSchedules,
  //   setScheduleChangesMade,
  //   setSiteSchedules,
  //   editMode,
  //   setSchedulesIndex,
  //   setEditModeTabSiteSchedules,
  // }: {
  //   clickedSchedulesTab: string;
  //   setClickedSchedulesTab: Dispatcher<string>;
  //   siteSchedules: any;
  //   visibleSchedules: any;
  //   setScheduleGrid: Dispatcher<any>;
  //   setTimeRanges: Dispatcher<any>;
  //   setGrid: Dispatcher<any>;
  //   setDuskToDawn: Dispatcher<any>;
  //   setDuskToDawnLocation: Dispatcher<any>;
  //   setSelectedDayInfo: Dispatcher<any>;
  //   setEditTimeScheduleDialogOpen: any;
  //   setMatchingSchedules: Dispatcher<any>;
  //   setScheduleChangesMade: any;
  //   setSiteSchedules: Dispatcher<any>;
  //   editMode: boolean;
  //   setSchedulesIndex: Dispatcher<number>;
  //   setEditModeTabSiteSchedules: any;
  // }
  {
    const {
      clickedSchedulesTab,
      setClickedSchedulesTab,
      siteSchedules,
      // visibleSchedules,
      setTimeRanges,
      setGrid,
      setDuskToDawn,
      setDuskToDawnLocation,
      setSelectedDayInfo,
      setSchedulesIndex,
    } = useSiteAboutStore();

    React.useEffect(() => {}, [clickedSchedulesTab]);

    return (
      <Box
        sx={{ maxWidth: { xs: 1320, sm: 1480 }, bgcolor: "background.paper" }}
      >
        <ThemeProvider theme={theme}>
          <Tabs
            value={clickedSchedulesTab}
            onChange={(event, newValue) => {
              if (newValue === "one") {
                localStorage.setItem("schedulesIndex", "0");
                setClickedSchedulesTab("one");
                setSchedulesIndex(0);
                setTimeRanges(
                  handleCreateInitialTimeSchedules(siteSchedules[0].schedule)
                );
                setGrid(
                  handleConvertSchedulesToBooleanArrays(
                    siteSchedules[0].schedule
                  )
                );
                setDuskToDawn(
                  handleCreateDuskToDawn(siteSchedules[0].schedule)
                );
                setDuskToDawnLocation(
                  handleCreateDuskToDawnLocationPlusBuffer(
                    siteSchedules[0].schedule
                  )
                );
                setSelectedDayInfo(siteSchedules[0]);
              } else if (newValue === "two") {
                localStorage.setItem("schedulesIndex", "1");
                setClickedSchedulesTab("two");
                setSchedulesIndex(1);
                setTimeRanges(
                  handleCreateInitialTimeSchedules(siteSchedules[1].schedule)
                );
                setGrid(
                  handleConvertSchedulesToBooleanArrays(
                    siteSchedules[1].schedule
                  )
                );
                setDuskToDawn(
                  handleCreateDuskToDawn(siteSchedules[1].schedule)
                );
                setDuskToDawnLocation(
                  handleCreateDuskToDawnLocationPlusBuffer(
                    siteSchedules[1].schedule
                  )
                );
                setSelectedDayInfo(siteSchedules[1]);
              } else if (newValue === "three") {
                localStorage.setItem("schedulesIndex", "2");
                setClickedSchedulesTab("three");
                setSchedulesIndex(2);
                setTimeRanges(
                  handleCreateInitialTimeSchedules(siteSchedules[2].schedule)
                );
                setGrid(
                  handleConvertSchedulesToBooleanArrays(
                    siteSchedules[2].schedule
                  )
                );
                setDuskToDawn(
                  handleCreateDuskToDawn(siteSchedules[2].schedule)
                );
                setDuskToDawnLocation(
                  handleCreateDuskToDawnLocationPlusBuffer(
                    siteSchedules[2].schedule
                  )
                );
                setSelectedDayInfo(siteSchedules[2]);
              }
            }}
            variant="scrollable"
            scrollButtons="auto"
          >
            {siteSchedules.length >= 1 && (
              <Tab
                label={
                  siteSchedules[0]
                    ? `${siteSchedules[0].display_name}`
                    : "Schedule 1"
                }
                value="one"
              />
            )}
            {siteSchedules.length >= 2 && (
              <Tab
                label={
                  siteSchedules[1]
                    ? `${siteSchedules[1].display_name}`
                    : "Schedule 2"
                }
                value="two"
              />
            )}
            {siteSchedules.length >= 3 && (
              <Tab
                label={
                  siteSchedules[2]
                    ? `${siteSchedules[2].display_name}`
                    : "Schedule 3"
                }
                value="three"
              />
            )}
          </Tabs>
        </ThemeProvider>
      </Box>
    );
  };
